import {
  Text,
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import { TellerSettingsView } from 'types/teller';

import { defaultPlaidInstitutionLogo } from '../constants';
import { ImageWithFallback } from '../ImageWithFallback';
import { InstitutionRemovalModal } from './InstitutionRemovalModal';
import { Icon } from '~/packages/common-frontend/components/icons';

export const AccountSelectionHeader = ({
  institutionWithAccounts,
  disconnectAccount,
  disconnectAccountIsLoading,
  refreshAccounts,
}: TellerSettingsView.AccountSelectionHeaderProps) => {
  const { logoUrl, name, itemId: tellerItemId } = institutionWithAccounts;

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="left"
      >
        <Box display="flex" alignItems="center">
          <ImageWithFallback
            fallbackUrl={defaultPlaidInstitutionLogo}
            height={32}
            width={32}
            defaultUrl={logoUrl}
            alt="Logo"
          />
          <Text fontWeight="bold" ml="10px">
            {name}
          </Text>
        </Box>
        <Box marginLeft="auto" marginRight="25px">
          <Menu>
            <MenuButton>
              <Icon icon="gear" />
            </MenuButton>
            <MenuList>
              <MenuItem
                onClick={() => {
                  refreshAccounts({ variables: { tellerItemId } });
                }}
              >
                Refresh Accounts
              </MenuItem>
              <MenuItem onClick={onOpen}>Remove Connection</MenuItem>
            </MenuList>
          </Menu>
          <InstitutionRemovalModal
            onClose={onClose}
            disconnectAccount={disconnectAccount}
            disconnectAccountIsLoading={disconnectAccountIsLoading}
            tellerItemId={tellerItemId}
            isOpen={isOpen}
            name={name}
          />
        </Box>
      </Box>
    </Box>
  );
};
